import { useState } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import axios from "axios";
import { API } from "../config";

export default function EmailV() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false); // 🔥 state switch
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);

    try {
      const response = await axios.post(
        `${API}/reset-password`,
        { email }
      );

      const newPassword = response.data.password;

      await emailjs.send(
        "service_7ortp3g",
        "template_y7tofbh",
        { email, password: newPassword },
        "S-V2yY6sriTrukATB"
      );

      setSuccess(true); // ✅ switch to success state

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#f6f7f8]">
      
      {/* HEADER */}
      <header className="w-full sticky top-0 bg-white z-50">
        <div className="flex justify-between items-center px-6 py-4 max-w-7xl mx-auto">
          <span className="text-xl font-bold text-gray-800">
            CareTech
          </span>
        </div>
      </header>

      {/* MAIN */}
      <main className="flex-grow flex flex-col items-center px-4 pt-28 relative overflow-hidden">

  {/* Background circles */}
  <div className="absolute top-[-10%] left-[-5%] w-72 h-72 bg-blue-200/30 rounded-full blur-[80px]"></div>
  <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-blue-300/20 rounded-full blur-[100px]"></div>

  {/* CARD */}
  <div className="w-full max-w-md bg-white/80 backdrop-blur-xl rounded-[2rem] p-10 shadow-xl border border-gray-200 z-10">

    {/* ===== STATE 1 ===== */}
    {!success && (
      <div className="flex flex-col items-center text-center">

        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-8">
          <span className="material-symbols-outlined text-blue-600 text-3xl">
            lock
          </span>
        </div>

        <h1 className="text-3xl font-extrabold mb-3 text-gray-800">
          Forgot Password
        </h1>

        <p className="text-gray-500 mb-10 px-4">
          Enter your email and we’ll send you a new password.
        </p>

        <form onSubmit={handleSubmit} className="w-full space-y-6">
          <div className="text-left">
            <label className="block text-sm font-semibold mb-2 ml-1 text-gray-600">
              E-mail
            </label>

            <input
              type="email"
              placeholder="example@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-5 py-4 rounded-xl bg-gray-50 border border-gray-200 focus:border-[#137fec] focus:ring-4 focus:ring-blue-100 outline-none"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-4 rounded-xl text-white font-bold text-lg shadow-lg transition-transform ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#137fec] hover:bg-[#0f6fd4] hover:scale-[1.02] active:scale-95"
            }`}
          >
            {loading ? "Sending..." : "Send New Password"}
          </button>
        </form>

        <button
          onClick={() => navigate("/signin")}
          className="text-blue-600 font-semibold text-sm hover:underline mt-6"
        >
          Return to login
        </button>
      </div>
    )}

    {/* ===== STATE 2 (SUCCESS) ===== */}
    {success && (
      <div className="flex flex-col items-center text-center">

        <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-8 relative">
          <div className="absolute inset-0 bg-blue-400/20 rounded-full animate-ping"></div>
          <span className="material-symbols-outlined text-blue-600 text-4xl">
            check_circle
          </span>
        </div>

        <h1 className="text-3xl font-extrabold mb-4 text-gray-800">
          Password Sent!
        </h1>

        <p className="text-gray-500 mb-10 px-4">
          A new password has been sent to your email.
        </p>

        <button
          onClick={() => navigate("/signin")}
          className="w-full py-4 rounded-xl bg-[#137fec] text-white font-bold text-lg hover:bg-[#0f6fd4] transition"
        >
          Continue
        </button>

        <button
          onClick={() => setSuccess(false)}
          className="text-blue-600 font-semibold text-sm hover:underline mt-6"
        >
          Go back
        </button>
      </div>
    )}

  </div>
</main>
    </div>
  );
}
